import { createErrorLogger, createLogger, LEVEL } from "./createLogger";
import { SentryTraceProvider } from "./sentryTraceProvider";

const Logger = {
  info: createLogger(LEVEL.info, SentryTraceProvider),
  debug: createLogger(LEVEL.debug, SentryTraceProvider),
  warning: createLogger(LEVEL.warning, SentryTraceProvider),
  error: createErrorLogger(SentryTraceProvider),
} as const;

export { Logger };
